export const SET_CATEGORY_LIST = "SET_CATEGORY_LIST"
export const SET_MEGA_MENU = "SET_MEGA_MENU"

